import React from 'react';
import reactStringReplace from 'react-string-replace';

/*
 * Utility fn to replace a [br] shortcode in a short text field, to be replaced by a regular <br /> tag.
 */

export const replaceLineBreakShortCode = (text) =>
  reactStringReplace(text, '[br]', (_m, i) => <br key={`br-${i}`} />);
